import FormValidator from '@/js/plugins/formValidator';
import { birthdayChangeAction } from '@/js/_components/parts/profile-add-guide';

const main = () => {
    if(!document.querySelector('#page-user-register-input')) return;
    const formValidator = new FormValidator({
        renderAreaSelector: '#input-form',
        renderErrorCnt: false,
        renderConfirmMessage: true,
        renderErrorPosition: 'outer',
    });

    birthdayChangeAction(formValidator.config.renderAreaObj);
}

export default main;
